import Swiper, { Navigation, Pagination, Thumbs, FreeMode } from 'swiper';

// eslint-disable-next-line no-new
new Swiper('.js-swiper', {
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
  autoplay: {
    delay: 5000
  }
});

document.querySelectorAll('.js-swiper-with-thumbs').forEach((mainEl) => {
  const container = mainEl.closest('.content-block__picture-gallery');
  const thumbsEl = container && container.querySelector('.js-swiper-thumbs');

  const thumbsSwiper = thumbsEl
    ? new Swiper(thumbsEl, {
        modules: [FreeMode],
        spaceBetween: 20,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true
      })
    : null;

  new Swiper(mainEl, { // eslint-disable-line no-new
    modules: [Navigation, Thumbs],
    spaceBetween: 10,
    navigation: {
      nextEl: mainEl.querySelector('.swiper-button-next'),
      prevEl: mainEl.querySelector('.swiper-button-prev')
    },
    thumbs: {
      swiper: thumbsSwiper
    }
  });
});
